module.exports = __webpack_public_path__ + "img/footer_logo_predixon.80ee4632.png";